module.exports = __webpack_public_path__ + "static/img/lb3.53e2c13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lb3.jpg
// module id = oMq8
// module chunks = 0